import { Td, Text, Tr } from '@chakra-ui/react';

interface TableNoResultsPlaceholderProps {
  text?: string;
}

const TableNoResultsPlaceholder: React.FC<TableNoResultsPlaceholderProps> = ({ text }) => {
  return (
    <Tr>
      <Td>
        <Text color="gray.500">{text ?? 'Nessun risultato trovato'}</Text>
      </Td>
    </Tr>
  );
};

export default TableNoResultsPlaceholder;
